import { initLogging } from './logger';
import { initMetrics } from './metrics/metrics';
import { initTracing } from './tracing/tracing';
export const initTelemetry = (config) => {
    initLogging(config.serviceName, config.logs);
    initTracing(config.serviceName, config.traces);
    initMetrics(config.serviceName, config.metrics);
};
export { getTracer } from './tracing/tracing';
export { getLogger } from './logger';
export { getMeter } from './metrics/metrics';
export * from './types';
//# sourceMappingURL=index.js.map